import { initializeApp, getApps } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Configuración de Firebase - MADERERÍA LA HUERTA
const firebaseConfig = {
  apiKey: "AIzaSyD-DLWzW_qvAYW03i0CZpj3rTGHYwA9O5E",
  authDomain: "madereria2025-e1e26.firebaseapp.com",
  databaseURL: "https://madereria2025-e1e26-default-rtdb.firebaseio.com",
  projectId: "madereria2025-e1e26",
  storageBucket: "madereria2025-e1e26.firebasestorage.app",
  messagingSenderId: "883026342740",
  appId: "1:883026342740:web:466b1989ca30fe518a0ec1"
};

// Inicializar Firebase solo si no ha sido inicializado ya
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// Exportar servicios de Firebase
export const auth = getAuth(app);
export const database = getDatabase(app);
export const db = getFirestore(app);

// Exportar la app principal
export default app;
